<script lang="ts">
    import LazyImage from './LazyImage.svelte';
    import StarRating from './StarRating.svelte';
    export let partner = {};
    export let ctaText = "";
    export let ctaColor = "";
    export let ctaTextColor = "fff";
    export let partnerRowBackgroundColor = "fff";
    export let displayStarRating = true;
</script>
<a rel="sponsored nofollow noreferrer" href="{partner['clickout_link']}"  target="_blank"  style="--primary: {ctaColor}">
    <div
        style="background-color: #{partnerRowBackgroundColor};"
            class="partner-row flex bg-white border border-transparent shadow-md py-1.5 px-2.5 items-center	mb-1.5 gap-x-2 justify-between">
        <LazyImage
                ImgClass="flex-1 max-h-14 h-full object-contain min-w-[80px] max-w-[100px]"
                src="{partner['logo_src']}"
                width="100"
                height="50"
                intrinsic_width="100"
                intrinsic_height="100"
                placeholder=""
                alt="{partner['name']}"
        />
 
        {#if partner['name']} 
            <div class="w-1/2 text-sm px-4 hidden sm:block">{@html partner['name']}</div>
        {/if}

        <div class="score flex flex-col items-center md:flex-row">
            <span class="mr-2">{partner['score']}</span>
        
            {#if displayStarRating}
            <StarRating
                iconWidth="20"
                score="{partner['score']}"
            />
            {/if}
        </div>

        <button
            style="background-color: #{ctaColor}; color: #{ctaTextColor};"
            class="flex items-center justify-center rounded-md text-white h-8 text-sm"
            type="button"
        >
            {ctaText}
       </button>
    </div>
</a>

<style lang="scss">
    .partner-row {
        button {
            min-width: 70px;
            max-width: 120px;
            width: 100%;
        }
    }

    .score {
        font-family: sans-serif;
        font-weight: bold;
        font-size: 16px;
        line-height: 20px;
        color: #333333;
    }
</style>